import {Component, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {MatDialog} from '@angular/material/dialog';
import {IFebActiviteUoNomenclature} from 'src/app/shared/models/feb-activite-uo-nomenclature';
import {AuthenticationService} from 'src/app/shared/services/authentication.service';
import {DialogService} from 'src/app/shared/services/dialog.service';
import {ThemeService} from 'src/app/shared/services/theme.service';
import {SnackbarService} from 'src/app/shared/services/snackbar.service';
import {FebActiviteUoNomenclatureService} from './feb-activite-uo-nomenclature.service';
import {FebActiviteUoNomenclatureDialogComponent} from './feb-activite-uo-nomenclature-dialog/feb-activite-uo-nomenclature-dialog.component';
import {ApplicationSettingsService} from '../application-settings/application-settings.service';
import * as fileSaver from 'file-saver';
@Component({
  selector: 'app-feb-activite-uo-nomenclature-management',
  templateUrl: './feb-activite-uo-nomenclature-management.component.html',
  styleUrls: ['./feb-activite-uo-nomenclature-management.component.less']
})
export class FebActiviteUoNomenclatureManagementComponent {

  nomenclatures!: MatTableDataSource<IFebActiviteUoNomenclature>;
  nomenclatureSelected!: IFebActiviteUoNomenclature;

  @ViewChild(MatSort)
  sort!: MatSort;

  displayedColumns: string[] = ['activiteUOoperationnelle', 'nomenclatureLabel', 'prixUO', 'prixUOmajore', 'actions'];

  constructor(
    public febActiviteUoNomenclatureService: FebActiviteUoNomenclatureService,
    public authenticationService: AuthenticationService,
    private dialogService: DialogService,
    private dialog: MatDialog,
    public theme: ThemeService,
    private snackbarService: SnackbarService,
    private applicationSettingsService: ApplicationSettingsService,
    private router: Router
  ) {
    this.nomenclatures = new MatTableDataSource();
    this.loadNomenclatures();
  }

  openErrorSnackBar(message: string) {
    this.snackbarService.openSnackBar(message, 'error-snack-bar');
  }

  openSuccessSnackBar(message: string) {
    this.snackbarService.openSnackBar(message);
  }

  goBack(): void {
    this.router.navigate(['/core/admin/centre-competence']);
  }

  loadNomenclatures(): void {
    this.febActiviteUoNomenclatureService.getAll().subscribe(value => {
      this.nomenclatures.data = value;
    });
  }

  selectedNomenclature(nomenclature: IFebActiviteUoNomenclature): void {
    this.nomenclatureSelected = nomenclature;
    this.nomenclatureSelected.check = true;
  }

  selectedNomenclaturePencil(nomenclature: IFebActiviteUoNomenclature): void {
    this.openDialog(nomenclature);
  }

  openDialog(nomenclature: IFebActiviteUoNomenclature | null = null): void {
    const dialogRef = this.dialog.open(FebActiviteUoNomenclatureDialogComponent, {
      width: '600px',
      data: nomenclature
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadNomenclatures();
      }
    });
  }

  initNomenclature(): void {
    this.nomenclatureSelected = {
      id: '',
      activiteUOoperationnelle: '',
      nomenclatureLabel: '',
      prixUO: undefined,
      prixUOmajore: undefined,
      check: false
    };
  }

  ngAfterViewInit(): void {
    this.nomenclatures.sort = this.sort;
  }

  updateNomenclatureList(): void {
    this.loadNomenclatures();
  }

  removeNomenclature(row: IFebActiviteUoNomenclature): void {
    this.dialogService.openConfirmDialog(row.nomenclatureLabel ?? '')
      .afterClosed().subscribe({
        next: res => {
          if (res) {
            this.febActiviteUoNomenclatureService.delete(row).subscribe({
              next: () => {
                this.loadNomenclatures();
                this.initNomenclature();
                this.snackbarService.openSnackBar('La nomenclature a été supprimée avec succès');
              },
              error: () => {
                this.snackbarService.openSnackBar('Une erreur est survenue lors de la suppression de la nomenclature', 'error-snack-bar');
              }
            });
          }
        }
      });
  }

  nomenclaturesFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.nomenclatures.filter = filterValue.trim().toLowerCase();
  }

   exportData() {
        this.febActiviteUoNomenclatureService.exportFebActiviteUONomenclatureData().subscribe({
          next: (data) => {
            if (data) {
              const blob: Blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              });
              window.URL.createObjectURL(blob);
              fileSaver.saveAs(
                blob,
                'Nomenclatures FEB - ' +
                this.applicationSettingsService.applicationSettings.CDS_name +
                ' - ' +
                new Date().toLocaleDateString().replace('_', '-') +
                ' ' +
                new Date().toLocaleTimeString().replace('_', '-'),
              );
              this.openSuccessSnackBar('Les nomenclatures de la FEB ont été exportées avec succès');
            } else {
              this.openErrorSnackBar('Aucune nomenclature de la FEB à exporter');
            }
          },
          error: (err) => {
            console.log(err);
            this.openErrorSnackBar("Une erreur est survenue lors de l'export des nomenclatures de la FEB");
          },
          complete: () => {
          }
        });
      }
}
